import React from 'react';
import {
	CardButton,
	CardLogo,
	CardLogoWrapper,
	CardTextWrapper,
	CardTimer,
	CardTitle,
	CardWrapper,
	LeftImage,
	Time
} from 'pages/landing/cards/styled';
import pnp from 'assets/img/landing/cards/pnp.svg';
import pnp_bg from 'assets/img/landing/cards/pnp_bg.png';
import vegas from 'assets/img/landing/cards/vegas.png';
import { Timer } from 'components/Timer';
import { useSelector } from 'react-redux';
import { getUpNextNFLEvent } from 'modules/selectors';
import { HOCisTrue } from 'components/HOCisTrue';
import { EnumEventStatus } from 'apps/BWW_PLAY_HUB/modules/utils';
import bet_mgm_logo from 'apps/BWW_PLAY_HUB/assets/img/bet_mgm.png';
import moment from 'moment-timezone';

export const UpNext: React.FC = () => {
	const event = useSelector(getUpNextNFLEvent);
	const isBettingAllowed = true;

	const isEventCompleted = event?.status === EnumEventStatus.Complete;
	const isEventLive = event?.status === EnumEventStatus.Active;
	const isEventScheduled = event?.status === EnumEventStatus.Scheduled;

	const isMoreThen24Hours = moment(event?.start).diff(moment(), 'h') > 24;
	const timerFormat = isMoreThen24Hours ? 'dd:hh:mm' : 'hh:mm:ss'

	const isEventCompletedClass = () => {
		return isEventCompleted ? 'completed' : '';
	}

	const isEventLiveClass = () => {
		return isEventLive ? 'live' : '';
	}

	return (
		<CardTextWrapper>
			<h3>Up Next</h3>
			<CardWrapper image={pnp_bg}>
				<CardLogoWrapper spbtw={isBettingAllowed}>
					<CardLogo src={pnp} alt="UpNext"/>
					<HOCisTrue when={isBettingAllowed}>
						<img src={bet_mgm_logo} alt="bet logo"/>
					</HOCisTrue>
				</CardLogoWrapper>
				<CardTitle>
					WIN A TRIP TO <br/>
					VEGAS FOR THE <br/>
					<span>2022 Draft</span>
				</CardTitle>
				<CardTimer>
					<HOCisTrue when={isEventScheduled}>
						<Timer
							key={'upNext'}
							format={timerFormat}
							separator={':'}
							date={new Date(event?.start || '').getTime()}
							as={Time}
						/>
					</HOCisTrue>
				</CardTimer>
				<CardButton className={`${isEventCompletedClass()} ${isEventLiveClass()}`}>
					<HOCisTrue when={isEventLive}>
						Live
					</HOCisTrue>
					<HOCisTrue when={isEventCompleted}>
						Completed
					</HOCisTrue>
					<HOCisTrue when={isEventScheduled}>
						Play now
					</HOCisTrue>
				</CardButton>
				<LeftImage src={vegas} alt="Las Vegas"/>
			</CardWrapper>
		</CardTextWrapper>
	);
}
